
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'FSelect'
})
class FSelect extends Vue {
  @Prop() readonly noDataText?: string

  private get noDataPlaceholder(): string {
    return this.noDataText || 'Keine Daten verfügbar'
  }
}

export default FSelect
